import DocumentSchema from '@/components/DocumentSchema';
import type { Table } from 'schema-dts';
import ChartDataTable from '@/pages/CompanyReport/components/Overview/components/ChartDataTable';
import { shallowEqual, useSelector } from 'react-redux';
import selector from '../selector';
import { useOverviewTranslation } from '@/pages/CompanyReport/components/OverviewSection/hooks/useOverviewTranslation';

const NextDividendTable = () => {
  const selected = useSelector<
    Parameters<typeof selector>[0],
    ReturnType<typeof selector>
  >(selector, shallowEqual);

  const t = useOverviewTranslation();

  return (
    <>
      <DocumentSchema<Table>
        item={{
          '@context': 'https://schema.org',
          '@type': 'Table',
          headline: t('fundamentals.dividend.table.heading', {
            companyName: selected?.companyName,
          }),
          about: t('fundamentals.dividend.table.description', {
            tickerSymbol: selected?.tickerSymbol,
          }),
        }}
      />
      <ChartDataTable
        data-cy-id="overview-dividend-table"
        columnTextAlignments="l"
      >
        <caption>
          {t('fundamentals.dividend.table.description', {
            tickerSymbol: selected?.tickerSymbol,
          })}
        </caption>
        <thead>
          <tr>
            <th colSpan={2}>
              {t('fundamentals.dividend.table.heading', {
                companyName: selected?.companyName,
              })}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{t('fundamentals.dividend.table.exDividend')}</td>
            <td>{selected?.dividendNextDateFormatted}</td>
          </tr>
          <tr>
            <td>{t('fundamentals.dividend.table.payDate')}</td>
            <td>{selected?.dividendNextPayDateFormatted}</td>
          </tr>
          <tr>
            <td>{t('fundamentals.dividend.table.daysUntilExDividend')}</td>
            <td>{selected?.daysUntilNextDate}</td>
          </tr>
          <tr>
            <td>{t('fundamentals.dividend.table.daysUntilPayDate')}</td>
            <td>{selected?.daysUntilNextPayDate}</td>
          </tr>
        </tbody>
      </ChartDataTable>
    </>
  );
};

export default NextDividendTable;
